import React, { VFC } from 'react';

import { Badge } from 'components/Badge';
import useMediaQuery from 'utils/useMediaQuery';
import { Button, ButtonSize, ButtonType } from 'components/Button';

import styles from './CarBadges.module.scss';

interface ICarBadges {
  badges: Array<string>;
  paginated?: boolean;
}

const PAGINATE_NUMBER = 6;

export const CarBadges: VFC<ICarBadges> = ({ badges, paginated }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <ul className={styles.ul}>
      {paginated
        ? badges.slice(0, PAGINATE_NUMBER).map((item) => (
            <li key={item}>
              <Badge variant="ghost" isInverted size={isMobile ? 'small' : 'medium'}>
                {item}
              </Badge>
            </li>
          ))
        : badges.map((item) => (
            <li key={item}>
              <Badge variant="ghost" isInverted size={isMobile ? 'small' : 'medium'}>
                {item}
              </Badge>
            </li>
          ))}
      {paginated && badges.length > PAGINATE_NUMBER ? (
        <li>
          <Button type={ButtonType.Button} size={ButtonSize.Medium} href="#equipment">{`+${
            badges.length - PAGINATE_NUMBER
          }`}</Button>
        </li>
      ) : null}
    </ul>
  );
};
